import { Component, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { AlunoPaades } from 'src/app/models/aluno-paades'
import { DataService } from 'src/app/services/data-service'
import { PropgService } from 'src/app/services/propg-service'

@Component({
  selector: 'app-propg-aluno-paades',
  templateUrl: './propg-aluno-paades.component.html',
  styleUrls: ['./propg-aluno-paades.component.css'],
  standalone: false
})
export class PropgAlunoPaadesComponent implements OnInit {
  anos: number[] = []
  anoSelecionado: number = 0
  data: AlunoPaades[] = []
  lastSearch: String = ''

  form = new FormGroup({
    cpf: new FormControl('', Validators.required),
  })

  constructor(private propgService: PropgService, private dataService: DataService) {}

  ngOnInit(): void {
    this.anos = this.dataService.listYearsSince2019()
    this.anoSelecionado = this.dataService.getCachedYearSince2019()
  }

  getData(): void {
    this.dataService.setCachedYearSince2019(this.anoSelecionado)
    if (this.form.controls['cpf'].getRawValue()!.length === 11) {
      this.propgService.alunoPaades(this.form.controls['cpf'].getRawValue()!, this.anoSelecionado).subscribe(data => {
        this.data = data
        this.lastSearch = this.form.controls['cpf'].getRawValue()!
      })
    }
  }

  filtrar() {
    if (this.form.controls['cpf'].getRawValue()!.length === 11) {
      this.getData()
    }
  }
}
